import { Component, OnInit, Inject, EventEmitter, Output, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { FormGroup, FormBuilder, AbstractControl, FormArray, FormControl } from '@angular/forms';
import { IAcceptTerm,  IProgramRule } from '@ebb-v2/ebb-integration';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DialogPdfReadComponent } from '../../directory/dialog-pdfread.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'ebb-portal-program-rules-acknowledge',
  templateUrl: './program-rules-acknowledge.component.html'
})
export class ProgramRulesAcknowledgeComponent implements OnInit {
 @Output() emitProgramRulesAcknowledge = new EventEmitter<boolean>();

  @Input('listRule') listRule: IProgramRule[];
  

  public formPermissions: FormGroup;
  public displayTerms: boolean;
  public disableSave = true;
  public displayProgramRulesAcknowledgeContent:string;
  public listterms: IAcceptTerm[] = [];
  termRead: Record<string, boolean> = {};
  public termsdescription: string="You will not be able to acknowledge the Terms and Conditions and Program Rules until you have reviewed and read them.";
  constructor(
    private readonly fb: FormBuilder ,
        public readonly sanitizer: DomSanitizer,
          private readonly dialog: MatDialog,
  ) { }

  ngOnInit() {
this.listterms = this.listRule.reduce(
  (acc, rule) => acc.concat(rule.acceptTerms),
  [] as IAcceptTerm[]
);

// sort by sequence ascending (smallest first)
this.listterms.sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0));
    this.initializeForm();
  }
ngOnChanges(): void {
this.listterms = [];
for (const r of this.listRule || []) {
  if (r?.acceptTerms?.length) this.listterms.push(...r.acceptTerms);
}
}

  private initializeForm(): void {
   const controls = this.listterms.map(t => {
      // if term has PDF and hasn't been read yet, keep disabled
      const disabled = !!t.pdfLink && !this.termRead[t.id];
      return new FormControl({ value: false, disabled });
    });

    const termsArray = this.fb.array(controls, { validators: this.allCheckedValidator });

    this.formPermissions = this.fb.group({
      terms: termsArray
    });
    
  }
  get termsArray(): FormArray {
  return this.formPermissions.get('terms') as FormArray;
}

getTermHtml(term: IAcceptTerm, index: number): SafeHtml {
  const html = (term.text ?? '').trim();
  const container = document.createElement('div');
  container.innerHTML = html;
if(term.pdfLink == null || term.pdfLink.trim() === '') { 

  return this.sanitizer.bypassSecurityTrustHtml(html);
}
  // Find any existing anchors
  const anchors = container.querySelectorAll('a');
  if (anchors.length > 0) {
    anchors.forEach(a => {
      const anchor = a as HTMLAnchorElement;
      anchor.removeAttribute('href');                 // <-- no navigation
      anchor.dataset.index = String(index); // <-- dataset API
      anchor.setAttribute('role', 'link');
      anchor.classList.add('term-link');
     });
      return this.sanitizer.bypassSecurityTrustHtml(container.innerHTML);
  }

  // If no anchor exists, but a PDF is available, append a clickable link
  if (term.pdfLink) {
    const link = document.createElement('a');
    link.removeAttribute('href');                 // <-- no navigation
    link.dataset.index = String(index);
    link.classList.add('term-link');
    link.textContent = 'Open PDF';
    link.setAttribute('role', 'link');
    const wrapper = document.createElement('span');
    wrapper.innerHTML = html || term.name || '';
    if (wrapper.innerHTML) wrapper.append(' ');
    wrapper.appendChild(link);

    return this.sanitizer.bypassSecurityTrustHtml(wrapper.innerHTML);
  }

  // No anchors and no pdfLink: return original text/HTML
  return this.sanitizer.bypassSecurityTrustHtml(html); 
}
onTermHtmlClick(e: MouseEvent): void {
  const link = (e.target as HTMLElement).closest('a.term-link') as HTMLAnchorElement | null;
  if (!link) return;
  e.preventDefault();

  const wrapper = link.closest('.term-html') as HTMLElement | null;
  const id = wrapper?.getAttribute('data-id');
  if (!id) return;

  const idx = this.listterms.findIndex(t => t.id === id);
  const term = idx >= 0 ? this.listterms[idx] : undefined;
  if (term) this.openPdf(term, idx);
}

  // Validator: all controls in the array must be true
  private allCheckedValidator = (ctrl: AbstractControl) => {
    const arr = ctrl as FormArray;
    const allTrue = arr.controls.every(c => c.value === true);
    return allTrue ? null : { notAllChecked: true };
  };
  public onChangeEventTerms(event): void {
    this.disableSave = !event.checked;
  }
openPdf(term: IAcceptTerm, index: number): void {


   const ref = this.dialog.open(DialogPdfReadComponent, {
    width: '90vw',
    height: '90vh',
    data: { url: term.pdfLink, title: "" },
    disableClose: true, 
    autoFocus: false
  });

  ref.afterClosed().subscribe((completed: boolean | undefined) => {
  if (completed === true) {
    this.termRead[term.id] = true;

    const ctrl = this.termsArray.at(index) as FormControl;
    if (ctrl.disabled) ctrl.enable({ emitEvent: true });

    ctrl.setValue(true); // check it
    ctrl.markAsTouched();
    ctrl.markAsDirty();

    this.termsArray.updateValueAndValidity({ emitEvent: true });
    this.formPermissions.updateValueAndValidity({ emitEvent: true });
  }
});

}
  public onClickYes(): void {
    this.emitProgramRulesAcknowledge.emit(true);
  }



}
